import { Messages } from 'lib/intl/messages';

export const messages: Messages = {
  SAVE: {
    en: 'Save',
    de: 'Speichern',
  },
  VALIDATE: {
    en: 'Validate',
    de: 'Validieren',
  },
  APPLY: {
    en: 'Apply',
    de: 'Anwenden',
  },
  CANCEL: {
    en: 'Cancel',
    de: 'Abbrechen',
  },
  DELETE: {
    en: 'Delete',
    de: 'Löschen',
  },
  LOGIN: {
    en: 'Login',
    de: 'Einloggen',
  },
  TRY_AGAIN: {
    en: 'Try again',
    de: 'Erneut versuchen',
  },
  RESTORE: {
    en: 'Restore',
    de: 'Wiederherstellen',
  },
  SUBMIT: {
    en: 'Submit',
    de: 'Senden',
  },
  SKIP: {
    en: 'Skip',
    de: 'Überspringen',
  },
  GOT_IT: {
    en: 'Got it',
    de: 'Gelesen',
  },
};
